// @flow
import React from "react";
import type { IconProps } from "../";

type Props = {
  ...IconProps,
  className?: string,
  onClick?: () => void
};

export default function IronTradeFlat({
  width = "35px",
  fill = "currentColor",
  ...props
}: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 34.921 25.661"
      fill={fill}
      width={width}
      {...props}
    >
      <g transform="translate(-0.066 0.097)">
        <path
          
          d="M2829.238-804.746l-1.608-1.616,3.568-3.588-2.9-2.913,7.664-7.708,2.9,2.913,3.552-3.573,1.607,1.617-3.552,3.573,2.9,2.913-7.664,7.708-2.9-2.913-3.567,3.588Zm2.334-8.173,4.184,4.208,4.334-4.358-4.184-4.208Z"
          transform="translate(-2809.036 830.31)"
        />
        <path
          
          d="M2456.1-980.107l3.572-3.593-2.9-2.917,16.889-16.986,2.9,2.917,3.439-3.459,1.611,1.62-3.439,3.459,2.888,2.907-16.889,16.986-2.888-2.907-3.572,3.592Z"
          transform="translate(-2456.035 1004.048)"
        />
      </g>
    </svg>
  );
}

export function IronTradeFull({
  width = "153px",
  fill = "currentColor",
  ...props
}: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 153.002 25.661"
      fill={fill}
      width={width}
      {...props}
    >
      <g transform="translate(-0.066 0.097)">
        <path
          d="M2829.238-804.746l-1.608-1.616,3.568-3.588-2.9-2.913,7.664-7.708,2.9,2.913,3.552-3.573,1.607,1.617-3.552,3.573,2.9,2.913-7.664,7.708-2.9-2.913-3.567,3.588Zm2.334-8.173,4.184,4.208,4.334-4.358-4.184-4.208Z"
          transform="translate(-2809.036 830.31)"
        />
        <path
          d="M2456.1-980.107l3.572-3.593-2.9-2.917,16.889-16.986,2.9,2.917,3.439-3.459,1.611,1.62-3.439,3.459,2.888,2.907-16.889,16.986-2.888-2.907-3.572,3.592Z"
          transform="translate(-2456.035 1004.048)"
        />
        <path
          d="M-350.9-111.573h3.006v16.626H-350.9Zm13.93,6.693a9.163,9.163,0,0,0-.99-.252,7.24,7.24,0,0,0-1.467-.132,5.769,5.769,0,0,0-1.014.1,6.064,6.064,0,0,0-.751.168v10.052h-2.886v-11.947a15.8,15.8,0,0,1,2.087-.588,12.94,12.94,0,0,1,2.779-.276q.286,0,.668.036t.763.1q.382.06.74.144t.572.156Zm13.787,3.647a8.141,8.141,0,0,1-.429,2.711,6.008,6.008,0,0,1-1.216,2.087,5.47,5.47,0,0,1-1.9,1.343,6.093,6.093,0,0,1-2.445.48,6.009,6.009,0,0,1-2.433-.48,5.5,5.5,0,0,1-1.884-1.343,6.158,6.158,0,0,1-1.228-2.087,7.941,7.941,0,0,1-.441-2.711,7.839,7.839,0,0,1,.441-2.7,6.078,6.078,0,0,1,1.24-2.075,5.483,5.483,0,0,1,1.9-1.331,6.081,6.081,0,0,1,2.409-.468,6.167,6.167,0,0,1,2.421.468,5.336,5.336,0,0,1,1.9,1.331,6.177,6.177,0,0,1,1.228,2.075A7.839,7.839,0,0,1-323.182-101.233Zm-2.958,0a4.917,4.917,0,0,0-.8-2.963,2.607,2.607,0,0,0-2.23-1.092,2.607,2.607,0,0,0-2.23,1.092,4.917,4.917,0,0,0-.8,2.963,5.019,5.019,0,0,0,.8,3,2.6,2.6,0,0,0,2.23,1.1,2.6,2.6,0,0,0,2.23-1.1A5.019,5.019,0,0,0-326.14-101.233Zm5.939-5.854a19.242,19.242,0,0,1,2.171-.456,18.612,18.612,0,0,1,2.958-.216,6.767,6.767,0,0,1,2.552.42,3.983,3.983,0,0,1,1.634,1.176,4.5,4.5,0,0,1,.859,1.823,10.24,10.24,0,0,1,.251,2.339v7.053h-2.886v-6.6a9.581,9.581,0,0,0-.131-1.715,3.051,3.051,0,0,0-.429-1.152,1.716,1.716,0,0,0-.811-.648,3.4,3.4,0,0,0-1.252-.2,9.562,9.562,0,0,0-1.145.072q-.6.072-.883.12v10.124H-320.2Z"
          transform="translate(399.227 116.704)"
        />
        <path
          d="M-46.621-122.945v2.615H-51.7v14.011h-3.029V-120.33h-5.081v-2.615Zm8.4,6.693a9.154,9.154,0,0,0-.99-.252,7.239,7.239,0,0,0-1.467-.132,5.77,5.77,0,0,0-1.014.1,6.067,6.067,0,0,0-.751.168v10.052h-2.886v-11.947a15.8,15.8,0,0,1,2.087-.588,12.939,12.939,0,0,1,2.779-.276q.286,0,.668.036t.763.1q.382.06.739.144t.572.156Zm6.894,7.893A10.68,10.68,0,0,0-29.3-108.5v-3.215a5.587,5.587,0,0,0-.692-.144,6.41,6.41,0,0,0-1-.072,6.625,6.625,0,0,0-.966.072,3,3,0,0,0-.883.264,1.6,1.6,0,0,0-.632.54,1.514,1.514,0,0,0-.239.876,1.539,1.539,0,0,0,.644,1.427A3.307,3.307,0,0,0-31.33-108.358Zm-.239-10.82a7.024,7.024,0,0,1,2.409.36,3.845,3.845,0,0,1,1.562,1.008,3.782,3.782,0,0,1,.835,1.571,7.732,7.732,0,0,1,.25,2.027v7.605q-.668.144-2.016.348a20.468,20.468,0,0,1-3.041.2,9.079,9.079,0,0,1-2.051-.216,4.3,4.3,0,0,1-1.586-.7,3.279,3.279,0,0,1-1.026-1.248,4.349,4.349,0,0,1-.37-1.9,3.677,3.677,0,0,1,.417-1.823,3.438,3.438,0,0,1,1.133-1.212,4.889,4.889,0,0,1,1.658-.672,9.279,9.279,0,0,1,1.968-.2,8.829,8.829,0,0,1,1,.06,9.289,9.289,0,0,1,1.121.2v-.48a3.777,3.777,0,0,0-.119-.96,1.993,1.993,0,0,0-.417-.8,1.953,1.953,0,0,0-.787-.54,3.389,3.389,0,0,0-1.228-.192,10.84,10.84,0,0,0-1.837.144,8.037,8.037,0,0,0-1.36.336l-.358-2.351a11.31,11.31,0,0,1,1.6-.384A12.462,12.462,0,0,1-31.569-119.178Zm10.853,6.549a4.576,4.576,0,0,0,.906,3.011,3.079,3.079,0,0,0,2.5,1.092,9.9,9.9,0,0,0,1.181-.06,7.92,7.92,0,0,0,.8-.132v-7.2a4.459,4.459,0,0,0-1.014-.492,3.943,3.943,0,0,0-1.348-.228,2.577,2.577,0,0,0-2.3,1.08A5.171,5.171,0,0,0-20.716-112.629Zm8.277,5.926a17.013,17.013,0,0,1-2.159.48,16.661,16.661,0,0,1-2.731.216,7.242,7.242,0,0,1-2.648-.456,5.515,5.515,0,0,1-1.992-1.307,5.764,5.764,0,0,1-1.264-2.063,7.915,7.915,0,0,1-.441-2.723,9.225,9.225,0,0,1,.37-2.7,5.916,5.916,0,0,1,1.085-2.075,4.841,4.841,0,0,1,1.741-1.331,5.636,5.636,0,0,1,2.361-.468,5.371,5.371,0,0,1,1.6.216,7.126,7.126,0,0,1,1.193.48v-6.022l2.886-.48Zm2.982-5.83a7.924,7.924,0,0,1,.489-2.9,6.1,6.1,0,0,1,1.3-2.075,5.379,5.379,0,0,1,1.861-1.248,5.732,5.732,0,0,1,2.147-.42,5.124,5.124,0,0,1,4.019,1.607,6.982,6.982,0,0,1,1.443,4.8q0,.24-.012.54t-.036.54H-6.475a3.317,3.317,0,0,0,1.061,2.339,4.017,4.017,0,0,0,2.731.828,8.931,8.931,0,0,0,1.92-.192,7.875,7.875,0,0,0,1.372-.408l.382,2.375a4.6,4.6,0,0,1-.656.252,9.223,9.223,0,0,1-.954.24q-.537.108-1.157.18a10.958,10.958,0,0,1-1.264.072A7.611,7.611,0,0,1-5.9-106.5a5.329,5.329,0,0,1-2-1.367,5.612,5.612,0,0,1-1.169-2.063A8.469,8.469,0,0,1-9.457-112.533Zm8.373-1.3a3.834,3.834,0,0,0-.167-1.14,2.754,2.754,0,0,0-.489-.936,2.315,2.315,0,0,0-.787-.624,2.5,2.5,0,0,0-1.109-.228,2.57,2.57,0,0,0-1.169.252,2.666,2.666,0,0,0-.847.66,3.02,3.02,0,0,0-.537.936,5.093,5.093,0,0,0-.262,1.08Z"
          transform="translate(151.266 128.081)"
        />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/Icons/Index/IronTrade.js